import { TokenOption } from 'uniswap/src/components/lists/items/types'
import { CurrencyInfo } from 'uniswap/src/features/dataApi/types'
import { currencyId } from 'uniswap/src/utils/currencyId'

export function mergeTokenOptionsLogoFallback({
  tokenOptions,
  fallbackTokenOptions,
  preferFallbackLogo = false,
}: {
  tokenOptions: TokenOption[] | undefined
  fallbackTokenOptions: (TokenOption[] | undefined)[]
  preferFallbackLogo?: boolean
}): TokenOption[] | undefined {
  if (!tokenOptions) {
    return undefined
  }

  const fallbackLogosByCurrencyId = new Map<string, { logoUrl: string; isNative: boolean }>()

  for (const options of fallbackTokenOptions) {
    for (const tokenOption of options ?? []) {
      const logoUrl = tokenOption.currencyInfo.logoUrl

      if (logoUrl) {
        fallbackLogosByCurrencyId.set(currencyId(tokenOption.currencyInfo.currency), {
          logoUrl,
          isNative: tokenOption.currencyInfo.currency.isNative,
        })
      }
    }
  }

  if (!fallbackLogosByCurrencyId.size) {
    return tokenOptions
  }

  return tokenOptions.map((option) => {
    const fallbackLogo = fallbackLogosByCurrencyId.get(option.currencyInfo.currencyId)

    // Native currencies should always use the canonical chain asset. The API can
    // return a non-empty but broken project URL (BNB is one example), which would
    // otherwise prevent the local asset fallback from ever being used.
    if (option.currencyInfo.logoUrl && !fallbackLogo?.isNative && !preferFallbackLogo) {
      return option
    }

    if (!fallbackLogo) {
      return option
    }

    const currencyInfo: CurrencyInfo = {
      ...option.currencyInfo,
      logoUrl: fallbackLogo.logoUrl,
    }

    return {
      ...option,
      currencyInfo,
    }
  })
}
